<template>
  <interview-short-cut-container>
    <div>
      <div
        v-if="loading"
        class="mx-auto"
      >
        <base-spinner size="medium-small" />
      </div>
      <div v-else-if="notes">
        <p
          v-if="!notes.length"
          class="text-center"
        >
          Aucune note interne n'a été enregistrée pour ce patient
        </p>
        <div
          v-else
          class="flex flex-col gap-3"
        >
          <div
            v-for="(note, index) in notes"
            :key="index"
            class="bg-white rounded-lg px-3 py-2 shadow-md"
          >
            <p
              v-if="note?.notes"
              class="text-sm"
              v-html="note.notes.replace(/\n/g, '<br>')"
            />
            <p class="text-end text-sm mt-1">
              {{ $filters.date(note.updated_at) }}
            </p>
          </div>
          <base-button
            v-if="meta && meta?.current_page < meta?.last_page"
            class="font-medium"
            :disabled="loading"
            @click="loadMore"
          >
            <base-spinner
              v-if="loading"
              size="button"
            />
            <span v-else>Voir plus</span>
          </base-button>
        </div>
      </div>
      <div v-else>
        <p class="text-center">
          Une erreur s'est produite lors du chargement des données.
        </p>
      </div>
    </div>
  </interview-short-cut-container>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import InterviewShortCutContainer from '@/interview/components/instance-modal/short-cuts/InterviewShortCutContainer.vue';
import { interviewApi } from '@/container';
import BaseSpinner from '@/core/components/base/spinner/BaseSpinner.vue';
import BaseButton from '@/core/components/base/BaseButton.vue';
import {mapState} from "pinia";
import {useInterviewStore} from "@/stores/interview-store";
import {InterviewArchive} from "@/interview/interfaces/interview";
import {MetaData} from "@/core/interfaces/api";

export default defineComponent({
    name: 'InterviewConsumerNotes',
    components: { BaseButton, BaseSpinner, InterviewShortCutContainer },
    data () {
        return {
            notes: [] as InterviewArchive[],
            loading: false,
            loadingMore: false,
            meta: null as MetaData | null
        };
    },
    computed: {
        ...mapState(useInterviewStore,['consumerKey'])
    },
    mounted () {
        this.loading = true;
        this.loadConsumerNotes()
            .finally(() => {
                this.loading = false;
            });
    },
    methods: {
    /**
     * Load consumer notes
     *
     * @param {Number} page
     * @returns {Promise<void>}
     */
        loadConsumerNotes (page: number = 1) {
            return interviewApi()
                .notes((this.consumerKey as string), page)
                .then((response) => {
                    this.meta = response.meta;
                    this.notes = [...(this.notes ?? []), ...response.data];
                });
        },
        /**
     * Load more notes.
     */
        loadMore () {
            if (this.meta && this.meta.current_page < this.meta.last_page) {
                this.loadingMore = true;
                this.loadConsumerNotes(this.meta.current_page + 1)
                    .finally(() => {
                        this.loadingMore = false;
                    });
            }
        }
    }
});
</script>
